import { ReviewInfo, ReviewConfig } from "./review-info";
export {ReviewInfo, ReviewConfig}